import { render, staticRenderFns } from "./verifieer.vue?vue&type=template&id=766c72a6&"
import script from "./verifieer.vue?vue&type=script&lang=js&"
export * from "./verifieer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports